//
import SlCustomerAccountReceivableModel from '@/models/Sale/SlCustomerAccountReceivable'

/**
 * This class describes a sl sale invoice.
 * @class      SlCustomerAccountReceivable (name)
 */
export default class SlCustomerAccountReceivable extends SlCustomerAccountReceivableModel {

	/**
	 * Returns a list representation of the object.
	 * @return     {Object}  List representation of the object.
	 */
	static toList() {

		/*
		this.appends = [
			/'account_receivable'
		]

		//
		this.includes = [
			'g_state',
			'sl_customer',
			'sl_customer_branch_offices',
			'sl_detail_sale_invoices.wh_product',
		]*/

		//
		return this
	}
}